import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerRoutines: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const [{ automationsRequestHandler }, { personalAutomationsRequestHandler }] = await Promise.all([import("./mocks/automationsRequestHandler.ts"), import("./mocks/personalAutomationsRequestHandler.ts")]);

        runtime.registerRequestHandlers([automationsRequestHandler, personalAutomationsRequestHandler]);
    }
};
